import {applySnapshot, Instance, getSnapshot, types} from 'mobx-state-tree';
import {useMemo} from 'react';
// import {HomeStore, initHomeStore} from './home';
import {DiagonalGrowthStore, initDiagonalGrowthStore} from './diagonal-growth';
import {initSettings, Settings} from '@/store/settings';
import {initNavBarStore, NavBarStore} from '@/store/nav-bar';

const RootStore = types.model({
  // home: HomeStore,
  navBar: NavBarStore,
  settings: Settings,
  diagonalGrowth: DiagonalGrowthStore,
}).actions(self => {
  let initialState = {};
  return {
    afterCreate: () => {
      initialState = getSnapshot(self);
    },
    reset: () => {
      applySnapshot(self, initialState);
    },
  };
});

export type RootStoreType = Instance<typeof RootStore>;

let store: RootStoreType;

export function resetStore() {
  store?.reset();
}

export function initializeStore(snapshot = null) {
  const _store =
    store ??
    RootStore.create({
      // home: initHomeStore(),
      navBar: initNavBarStore(),
      settings: initSettings(),
      diagonalGrowth: initDiagonalGrowthStore(),
    });
  if (snapshot) {
    applySnapshot(_store, snapshot);
  }
  if (typeof window === 'undefined') {
    return _store;
  }
  if (!store) {
    store = _store;
  }
  return store;
}

export function useStore(initialState): Instance<typeof RootStore> {
  return useMemo(() => initializeStore(initialState), [initialState]);
}
